/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/express';

/**
 * duplicateCartItem
 * url - /checkout/{apiversion}/cart/{cartId}/duplicate?brand={brandId}
 *
 * @param {Object} wcEnv
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {String} args.referenceId
 * @param {String} args.primaryBrand
 * @param {array} args.products
 * @param {object} args.customer
 * @param {object} args.promotion
 * @param {array} args.attributes
 */
const expressCheckout = ({
    env, jwtToken, payload,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const resourcePage = `${RESOURCE_PAGE_CARTSERVICE}${RESOURCE_PAGE_ACTION}`;

    return restClient.postRequest(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default expressCheckout;
